import { JAVA_API_STATUS } from '../../utils/axios-interceptor';
import { fetchHistory, FetchHistoryPayload } from './HistoryDrawerApiService';
import { AicaHistoryResponse, ManagementProfileHistoryResponse, HistoryEntry } from '../../types/ownerHistory';

export const getHistory = async (payload: FetchHistoryPayload): Promise<HistoryEntry[] | false> => {
    try {
        // polus BEFE: the MANAGEMENT_PROFILE branch's outer responseData stays
        // fixed at 20 regardless of the underlying aica call — the unifier cannot express a
        // failed/absent upstream call as an HTTP status or its own responseCode.
        // `transformManagementProfileFieldHistory` (polus DataTransformationScript.groovy)
        // emits the real verdict as `fieldHistory.status` instead ('OK' | 'FAILED'). A
        // FAILED load must surface as `false` (error state), never as an empty result — the
        // ACCOUNT branch below is untouched and keeps reading `.data` byte-for-byte (A-50).
        if (payload.historySource === 'MANAGEMENT_PROFILE') {
            const response = await fetchHistory(payload);
            const fieldHistory = (response.data as ManagementProfileHistoryResponse)?.responseBody?.fieldHistory;
            if (!fieldHistory || fieldHistory.status !== 'OK') return false;
            return fieldHistory.entries ?? [];
        }

        const response = await fetchHistory(payload);
        const apiResponse = response.data as AicaHistoryResponse;
        if (apiResponse.responseData.responseCode === JAVA_API_STATUS.SUCCESS) {
            return apiResponse.data ?? [];
        }

        return false;
    } catch (err) {
        return false;
    }
};
